import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { logBootstrapError } from './app/services/signal-vault-log';

bootstrapApplication(AppComponent, appConfig).catch(logBootstrapError);
